// Australian mobile phone formatter — used by phone inputs and display.
// Rules:
// • Capped at 10 digits.
// • Numbers that start with "04" get formatted as `04xx xxx xxx` (4-3-3 grouping).
// • Anything else is rendered as plain digits (no spaces) until/unless the user
//   corrects the prefix to "04".

export const cleanPhoneDigits = (value) =>
  String(value || '').replace(/\D/g, '').slice(0, 10);

export const formatAuPhone = (value) => {
  const digits = cleanPhoneDigits(value);
  if (!digits) return '';
  if (!digits.startsWith('04')) return digits;
  // 4-3-3 grouping for AU mobiles: 0412 345 678
  const parts = [digits.slice(0, 4), digits.slice(4, 7), digits.slice(7, 10)].filter(Boolean);
  return parts.join(' ');
};

export const PHONE_PLACEHOLDER = '04xx xxx xxx';
